// v10/src/i18n/index.js
// v2.0 — Limpieza: eliminado idioma 'es' genérico. Solo es-AR (canónico para Argentina) y en.
// Migración automática: si el usuario tenía 'es' guardado en localStorage, lo pasamos a 'es-AR'.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import esARCommon    from '../locales/es-AR/common.json';
import esARChecklist from '../locales/es-AR/checklist.json';
import esARAdmin     from '../locales/es-AR/admin.json';
import esARAuth      from '../locales/es-AR/auth.json';
import esARAbout     from '../locales/es-AR/about.json';

import enCommon    from '../locales/en/common.json';
import enChecklist from '../locales/en/checklist.json';
import enAdmin     from '../locales/en/admin.json';
import enAuth      from '../locales/en/auth.json';
import enAbout     from '../locales/en/about.json';

// ✅ Migración: usuarios que tenían 'es' guardado pasan a 'es-AR' automáticamente
const savedLang = localStorage.getItem('condor360_language');
if (savedLang === 'es') {
  localStorage.setItem('condor360_language', 'es-AR');
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'es-AR': { common: esARCommon, checklist: esARChecklist, admin: esARAdmin, auth: esARAuth, about: esARAbout },
      en:      { common: enCommon,   checklist: enChecklist,   admin: enAdmin,   auth: enAuth,   about: enAbout   },
    },
    fallbackLng: 'es-AR',
    defaultNS: 'common',
    ns: ['common', 'checklist', 'admin', 'auth', 'about'],
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'condor360_language',
      caches: ['localStorage'],
    },
    // ✅ Si no hay idioma guardado, usar es-AR por defecto
    lng: localStorage.getItem('condor360_language') || 'es-AR',
    interpolation: { escapeValue: false },
  });

export default i18n;
